import * as React from 'react';
import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import styled from '@emotion/styled';
import { Avatar, Typography } from '@mui/material';
import { useTheme } from '@mui/system';
import { User } from '@auth0/auth0-spa-js';
import { Auth0ContextInterface } from '@auth0/auth0-react/src/auth0-context';
import { PersonOutlineAnalyticInterface } from './PersonOutline.interface';
import { analyticInfoRowStyle, analyticInfoStyle, headerStyle, profileAnalyticStyled, profileWrapperStyle } from './PersonOutline.mock';

const StyledProfileWrap = styled.div(profileWrapperStyle);

const StyledProfileAnalytic = styled.div(profileAnalyticStyled);

const StyledAnalyticRow = styled.span(analyticInfoRowStyle);

const StyledAnalyticInfo = styled.div(analyticInfoStyle);

const StyledAnalyticCell = styled.span`
  flex: 1;
`;

const AnalyticCell = ({ value, title }: PersonOutlineAnalyticInterface) => (
  <StyledAnalyticCell>
    <Typography variant="h6">{title}</Typography>
    <Typography>{value}</Typography>
  </StyledAnalyticCell>
);

const PersonOutline = () => {
  const { getIdTokenClaims, user }: Auth0ContextInterface = useAuth0();
  React.useEffect(() => {}, [getIdTokenClaims, user]);

  const {
    palette: {
      primary: { main: ThemeColor },
    },
  } = useTheme();

  const avatarProps = ({ name }: User) => ({
    children: `${name?.split(' ')?.[0]?.[0] ?? ''}${name?.split(' ')?.[1]?.[0] ?? ''}`,
    sx: {
      background: ThemeColor,
      width: '5rem',
      height: '5rem',
      fontSize: '2.5rem',
      marginRight: '1rem',
    },
  });

  if (!user) return <h2>No user</h2>;

  return (
    <StyledProfileWrap>
      <Typography sx={headerStyle} variant="h5">
        Profile info
      </Typography>
      <StyledProfileAnalytic>
        <Avatar {...avatarProps(user)} alt={user?.name} />
        <StyledAnalyticInfo>
          <StyledAnalyticRow>
            <AnalyticCell title="Name" value={user.name ?? ''} />
            <AnalyticCell title="Email" value={user?.email ?? ''} />
          </StyledAnalyticRow>
          <StyledAnalyticRow>
            <AnalyticCell title="Role" value={user?.[`${process.env.REACT_APP_METADATA_FOR_ROLES}/roles`]?.[0] ?? ''} />
            <AnalyticCell title="Authentication Method" value={user?.[`${process.env.REACT_APP_METADATA_FOR_ROLES}/claims/connection`] ?? ''} />
          </StyledAnalyticRow>
        </StyledAnalyticInfo>
      </StyledProfileAnalytic>
    </StyledProfileWrap>
  );
};

export default withAuthenticationRequired(PersonOutline, {
  onRedirecting: () => <div>Redirecting you to the login page...</div>,
});
